/**
 * ヘッダー：スクロールで背景を白に切り替え（トップページのみ透過スタート）
 */
let header = () => {
  const el = document.getElementById('g-header');
  if (!el || el.classList.contains('lower')) return;

  ScrollTrigger.create({
    start: 60,
    onEnter: () => el.classList.add('is-scrolled'),
    onLeaveBack: () => el.classList.remove('is-scrolled'),
  });
};

/**
 * 初期化
 */
let init = () => {
  header();
};

export default { init, header };
